import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Only run in browser
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    // Check if fbq already exists
    if ((window as any).fbq) {
      return;
    }
    // Initialize Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any) {
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e);
      t.async = true;
      t.src = v;
      // Safely append to head
      const head = b.getElementsByTagName('head')[0];
      if (head) {
        head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
    // Initialize with your Pixel ID
    ;
    (window as any).fbq('init', '1948436596104900');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-137">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1948436596104900&ev=PageView&noscript=1" alt="" data-id="element-138" />
    </noscript>;
}